import React from 'react'
import ReactDOM from 'react-dom'
// import './index.css'
// Mobilekit base styles (previously pulled in by Footer.js)
import './index.css'
import App from './App'
// Theme layer — keep as the LAST css import so it overrides Mobilekit/Bootstrap
import './styles/theme.css'
import { store } from './app/store'
import { Provider } from 'react-redux'
import * as serviceWorker from './serviceWorker'

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
